import { getVisibleArrows } from './utils/get-visible-arrows.js';
import { PanningControls } from '../../../core/components/axes/components/PanningControls/PanningControls.js';
import { useAxesConfig } from '../../hooks/useAxesConfig.js';
import { useXYChartData } from '../../hooks/useXYChartData.js';
import { useXYChartScales } from '../../hooks/useXYChartScales.js';
import { isXAxis } from '../../utils/is-axis.js';

interface XYChartPanningControlsProps {
  onClickPan: (domain: number) => void;
}

export const XYChartPanningControls = (props: XYChartPanningControlsProps) => {
  const { onClickPan } = props;

  const {
    axesMetadata: { isInfinite },
  } = useXYChartData();

  const xAxes = useAxesConfig().filter(isXAxis);
  const scales = useXYChartScales();

  const [left, right] = getVisibleArrows(xAxes, isInfinite, scales);

  return (
    <PanningControls
      onClickPan={onClickPan}
      showLeftControl={left}
      showRightControl={right}
    />
  );
};
